module.exports = new __parcel__URL__("jsm-project-summary.e40ecefa.svg").toString();